module.exports = __webpack_public_path__ + "img/c-xcx.8aba6df8.png";